import React, { useState } from "react";

// imported icons ===========>
import { AiFillHeart } from "react-icons/ai";
import { BsArrowRightShort } from "react-icons/bs";
import { AiOutlineHeart } from "react-icons/ai";

// imported Images ===========>
import BarChart from "../../../Chart/BarChart";
import LineChart from "./../../../Chart/LineChart";
import PieChart from "./../../../Chart/PieChart";
import { UserData } from "./../../../../data/Userdata";
import InventoryAlert from "./InventoryAlert";
import { BuyData } from "../../../../data/BuyData";
import { RatingData } from "./../../../../data/RatingData";
import { OrderData } from "./../../../../data/OrderData";
import NewOrderData from "./NewOrderData";
import PendingOrder from "./PendingOrder";
import { SavingData } from "./../../../../data/SavingData";
import TopBuyingSKUData from "./TopBuyingSKUData";

const Graphs = ({ myAccount }) => {
  const [buyData, setSaleData] = useState({
    labels: BuyData.map((data) => data.year),
    datasets: [
      {
        label: "Buying Chart",
        data: BuyData.map((data) => data.sale),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(255, 159, 64, 0.2)",
          "rgba(255, 205, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(201, 203, 207, 0.2)",
        ],
        borderColor: [
          "rgb(255, 99, 132)",
          "rgb(255, 159, 64)",
          "rgb(255, 205, 86)",
          "rgb(75, 192, 192)",
          "rgb(54, 162, 235)",
          "rgb(153, 102, 255)",
          "rgb(201, 203, 207)",
        ],
        borderWidth: 1,
      },
    ],
  });

  const [savingData, setOrderData] = useState({
    labels: SavingData.map((data) => data.year),
    datasets: [
      {
        label: "Saving Chart",
        data: SavingData.map((data) => data.save),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(255, 159, 64, 0.2)",
          "rgba(255, 205, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(201, 203, 207, 0.2)",
        ],
        borderColor: [
          "rgb(255, 99, 132)",
          "rgb(255, 159, 64)",
          "rgb(255, 205, 86)",
          "rgb(75, 192, 192)",
          "rgb(54, 162, 235)",
          "rgb(153, 102, 255)",
          "rgb(201, 203, 207)",
        ],
        borderWidth: 1,
      },
    ],
  });

  return (
    <>
      <div className="lisitingSection">
        <div className="heading flex">
          <h1
            style={{ width: "100%", textAlign: "center", marginTop: "0.5rem" }}
          >
            My Progress
          </h1>
          {/* <button className='btn flex'>
          See All <BsArrowRightShort className="icon"/>
        </button> */}
        </div>

        <div className="body flex">
          <div className="row w-100">
            {/* <div className="col-md-6">
              <div className="chart pb-3">
                <h5>Buying Chart</h5>
                <div style={{ width: 450 }}>
                  <LineChart chartData={buyData} />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="chart pb-3">
                <h5>Saving Chart</h5>
                <LineChart chartData={savingData} />
              </div>
            </div> */}

            <div className="col-md-6">
              <div className="chart pb-3">
                <NewOrderData myAccount={myAccount} />
              </div>
            </div>

            {/* <div className="col-md-6">
              <div className="chart pb-3">
                <h5>Pending Order</h5>
                <PendingOrder />
              </div>
            </div> */}

            {/* <div className="col-md-6">
              <div className="chart pb-3">
                <h5>Inventory Alert</h5>
                <InventoryAlert />
              </div>
            </div> */}

            {/* <div className="col-md-6">
              <div className="chart pb-3">
                <h5>Top Buying SKU</h5>
                <TopBuyingSKUData />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Graphs;
